import moment from 'moment';
export function isSameDay(currentMessage, diffMessage) {
  if (!diffMessage || !diffMessage.createdAt) {
    return false;
  }

  var currentCreatedAt = moment(currentMessage.createdAt);
  var diffCreatedAt = moment(diffMessage.createdAt);

  if (!currentCreatedAt.isValid() || !diffCreatedAt.isValid()) {
    return false;
  }

  return currentCreatedAt.isSame(diffCreatedAt, 'day');
}
export function isSameUser(currentMessage, diffMessage) {
  return !!(diffMessage && diffMessage.user && currentMessage.user && diffMessage.user._id === currentMessage.user._id);
}

var styleString = function styleString(color) {
  return "color: ".concat(color, "; font-weight: bold");
};

var headerLog = '%c[react-native-gifted-chat]';
export var warning = function warning() {
  var _console;

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (_console = console).log.apply(_console, [headerLog, styleString('orange')].concat(args));
};
export var error = function error() {
  var _console2;

  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return (_console2 = console).log.apply(_console2, [headerLog, styleString('red')].concat(args));
};